<template>
    <div :class="['navbar-area bg-white p-relative', {'is-sticky': isSticky}]">
        <div class="benovium-nav">
            <div class="container">
                <nav class="navbar navbar-expand-lg navbar-light">
                    <router-link class="navbar-brand" to="/">
                        <img src="../../assets/img/bd_logo.jpeg" alt="logo" style="height: 6vh">
                    </router-link>

                    <div
                        class="navbar-toggler"
                        @click="active = !active" :aria-pressed="active ? 'true' : 'false'"
                        v-bind:class="{ 'active': button_active_state }"
                        v-on:click="button_active_state = !button_active_state"
                    >
                        <span class="icon-bar top-bar"></span>
                        <span class="icon-bar middle-bar"></span>
                        <span class="icon-bar bottom-bar"></span>
                    </div>

                    <div class="collapse navbar-collapse" :class="{ show: active }" is-nav>
                        <ul class="navbar-nav">
                            <li class="nav-item">
                                <router-link to="/" class="nav-link">START</router-link>
                            </li>

                            <!-- <li class="nav-item">
                                <a href="#" class="nav-link">
                                    LEISTUNGEN <i class="bx bx-chevron-down"></i>
                                </a>
                                <ul class="dropdown-menu">
                                    <li class="nav-item">
                                        <router-link to="/services/webentwicklung" class="nav-link">Webentwicklung</router-link>
                                    </li>
                                    <li class="nav-item">
                                        <router-link to="/services/seo" class="nav-link">SEO-Optimierung</router-link>
                                    </li>
                                    <li class="nav-item">
                                        <router-link to="/services/betreuung" class="nav-link">Betreuung & Wartung</router-link>
                                    </li>
                                    <li class="nav-item">
                                        <router-link to="/services/it-beratung" class="nav-link">IT-Beratung</router-link>
                                    </li>
                                </ul>
                            </li> -->

                            <li class="nav-item">
                                <router-link to="/referenzen" class="nav-link">REFERENZEN</router-link>
                            </li>

                            <li class="nav-item">
                                <router-link to="/about" class="nav-link">ÜBER UNS</router-link>
                            </li>

                            <li class="nav-item">
                                <router-link to="/contact" class="nav-link">KONTAKT</router-link>
                            </li>
                        </ul>

                        <div class="others-options">
                            <router-link to="/contact" class="default-btn">
                                <i class="bx bxs-hot"></i>JETZT STARTEN<span></span>
                            </router-link>
                        </div>
                    </div>
                </nav>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NavbarStyleTwo',
    data(){
        return {
            isSticky: false,
            active: false,
            button_active_state: false
        }
    },

    mounted(){
        const that = this
        window.addEventListener('scroll', () => {
            let scrollPos = window.scrollY
            if(scrollPos >= 100){
                that.isSticky = true
            } else {
                that.isSticky = false
            }
        })
    },
}
</script>
